var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"fixed-bottom"},[_c('div',{staticClass:"bg-primary text-white text-sm-center fs-6"},[_vm._v("Languages Editor - Copy rights 2024 "+_vm._s(_vm.nextYear))])]),_c('toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }